import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import de from './locales/de/translation.json';
import { DEFAULT_LANGUAGE } from './config/languages.js';

// the translations, keyed by the same codes used as URL prefixes
const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
};

// Language is derived purely from the URL (see <LanguageSync />), not
// from browser locale or a stored preference, so no language detector
// is used here — <LanguageSync /> calls i18n.changeLanguage() on every
// navigation based on the current path.
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
